<template>
  <b-form @submit.prevent="evOnSubmit">
    <b-row>
      <b-col cols="12" class="mt-0 pt-0">
        <v-text-field
          type="email"
          label="E-mail"
          autofocus
          outlined
          dense
          hide-details
          :disabled="loading"
          v-model="email"
        />
      </b-col>
      <b-col cols="12" class="mt-0 pt-0">
        <errors-messages :errors="errors" />
      </b-col>
      <b-col cols="12" class="mt-0 pt-0">
        <v-btn
          type="submit"
          class="btn-acess btn-block"
          block
          :disabled="loading"
        >
          VERIFICAR
        </v-btn>
      </b-col>
      <b-col cols="12" class="mt-0 pt-0">
        <v-btn
          class="btn-block"
          text
          block
          :disabled="loading"
          @click="$router.push({ name: 'new-password' })"
        >
          ESQUECI MINHA SENHA
        </v-btn>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
export default {
  name: "VerifyEmail",

  components: { ErrorsMessages },

  data() {
    return {
      errors: [],
      loading: false,

      email: "",

      security_questions: [],
      users: [],
    };
  },

  mounted() {
    this.errors = [];
    this.loading = false;
    this.email = "";
  },

  created() {
    this.errors = [];
    this.loading = false;
    this.email = "";
  },

  methods: {
    async evOnSubmit() {
      try {
        this.loading = true;
        this.errors = [];

        this.email = this.email.trim();
        const email = this.email;
        if (!email) {
          this.errors.push("INFORME O E-MAIL");
          return;
        }

        const response = await api.post("/rest-home/user/verify/email", {
          email,
        });
        const { error, errors, clients, device_code, offline } = response.data;

        if (device_code) localStorage.setItem("device_code", device_code);

        if (offline) {
          const user = await this.findUser();
          if (user) this.$emit("success", { email, offline, user });
        } else {
          if (error) {
            this.errors = errors;
          } else {
            this.$emit("success", { email, clients, offline });
          }
        }
      } catch (error) {
        this.errors.push("OCORREU UM ERRO NO APLICATIVO");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getSecurityQuestions() {
      try {
        const response = await api.get("/default/security-questions");
        const { security_questions } = response.data;
        this.security_questions = security_questions;
      } catch (error) {
        console.log(error);
      }
    },

    async getOfflineAccess() {
      try {
        const response = await api.get("/rest-home/users/offline-access");
        const { users } = response.data;
        this.users = users;
      } catch (error) {
        console.log(error);
      }
    },

    async findUser() {
      await this.getSecurityQuestions();
      await this.getOfflineAccess();

      if (!this.security_questions || !this.users) {
        this.errors.push(
          "INFORMAÇÕES DE ACESSO OFFLINE NÃO DISPONÍVEIS. FAÇA LOGIN ONLINE PARA SINCRONIZAR"
        );
        return undefined;
      }

      let user = this.users.find((user) => user.email == this.email);

      if (!user) {
        this.errors.push(
          "USUÁRIO INVÁLIDO OU NÃO DEFINIU AS PERGUNTAS DE SEGURANÇA"
        );
        return undefined;
      }

      const first_security_question_statement = this.security_questions.find(
        (question) => question.id == user.first_security_question_id
      )?.statement;

      const last_security_question_statement = this.security_questions.find(
        (question) => question.id == user.last_security_question_id
      )?.statement;

      if (
        !first_security_question_statement ||
        !last_security_question_statement
      ) {
        this.errors.push("USUÁRIO NÃO DEFINIU AS PERGUNTAS DE SEGURANÇA");
        return undefined;
      }

      user = {
        ...user,
        first_security_question_statement,
        last_security_question_statement,
      };

      return user;
    },
  },
};
</script>

<style>
</style>